import { Box, CircularProgress, styled } from '@mui/material'
import { ReactNode, useRef } from 'react'
import { SwitchTransition, CSSTransition } from 'react-transition-group'

interface StyleProps {
  timeout: number
}

const MyCSSTransition = styled(CSSTransition)<StyleProps>(({ timeout }) => ({
  enter: {
    opacity: 0,
  },
  exit: {
    opacity: 1,
  },
  enterActive: {
    transition: `opacity ${timeout}ms`,
    opacity: 1,
  },
  exitActive: {
    transition: `opacity ${timeout}ms`,
    opacity: 0,
  },
}))

export interface LoadingWrapperProps {
  loaded?: boolean
  size?: number | string
  children?: ReactNode
  timeout?: number
}

export default function LoadingWrapper({
  size,
  children,
  loaded = false,
  timeout = 200,
}: LoadingWrapperProps) {
  const childRef = useRef(null)
  const progRef = useRef(null)
  return (
    <SwitchTransition>
      <MyCSSTransition key={loaded ? 1 : 0} timeout={timeout} nodeRef={loaded ? progRef : childRef}>
        {loaded ? (
          <div style={{ height: '100%' }} ref={childRef}>
            {children}
          </div>
        ) : (
          <Box
            ref={progRef}
            sx={{
              width: '100%',
              height: '100%',
              minHeight: 300,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              p: 4,
            }}
          >
            <CircularProgress size={size} />
          </Box>
        )}
      </MyCSSTransition>
    </SwitchTransition>
  )
}
